import {Boot} from '@/project'
import ScriptCodeInjector from '@/lib/script-code-injector'

declare module 'vue/types/vue' {
  interface VueConstructor {
    readonly scriptCodeInjector: ScriptCodeInjector
  }
}

const boot: Boot = ({Vue}) => {
  Vue.use(ScriptCodeInjector)
}

export default boot
